module.exports = __webpack_public_path__ + "img/bbb93afd8ad604b23f52e152fed7489b.png";